<template>
  <b-card class="card-congratulation-medal" v-if="!message">
    <h5>
      {{ getHowMonth }} En İyi 3 Fenomen {{ message }}
    </h5>
    <chartjs-horizontal-bar-chart :chartData="chartDataHorizontal" :loadChart="loadChart" :totalAmount="totalAmount"  :heightChart="240" :hasParcent="false"/>
    <b-img
      :src="require('@/assets/images/illustration/badge.svg')"
      class="congratulation-medal"
      width="40px"
      alt="Medal Pic"
    />
    <router-link :to="{ name: 'analysis-fenomen' }" class="float-right">Tümünü Gör</router-link>
  </b-card>
  <b-card class="card-congratulation-medal text-danger" v-else>
    {{ message }}
  </b-card>

</template>

<script>
import {
  BCard, BCardText, BLink, BImg,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import ChartjsHorizontalBarChart from '@/views/analysis/ChartjsHorizontalInfluencer.vue';
export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BImg,
    ChartjsHorizontalBarChart
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      topInfluencer: {
        name: '',
        username: '',
        totalAmount: 0,
      },
      message: null,
      dataList:[],
      loadChart:false,
      chartData: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor:  '#28dac6',
            borderColor: 'transparent',
            barThickness: 15
          },
        ],
      },
      chartDataHorizontal: {},
    };
  },
  methods: {
    async fetchTopInfluencer(startDate=null,endDate=null) {
      this.$http.get('/analysis/influencer', { params: { start_date: startDate, end_date: endDate, perPage : 3, source:'homepage' } }).then((response) => {
        // Dönen fenomen listesini al
        const data = response.data.data.hasOrder;


        if(!response.data.success){
          this.message = response.data.message;
          this.loadChart = true;
        } else {
        // Fenomenleri total_amount değerine göre azalan sırayla sıralayın
          this.dataList = data.sort((a, b) => b.total_amount - a.total_amount);
          // Grafikleri güncelle
          this.updateChartData();
        }

      }).catch((error) => {
        console.error('Veri alımı sırasında bir hata oluştu:', error);
      });
    },
    updateChartData(){
      this.loadChart=false;
      
      const labels = this.dataList.map((item)=>{
        return item.name_surname
      })
      const dataAmount = this.dataList.map((item)=>{
        return [item.total_count, item.total_amount]
      })

      this.chartDataHorizontal = JSON.parse(JSON.stringify(this.chartData));
      this.chartDataHorizontal.labels = [...labels];
      this.chartDataHorizontal.datasets[0].data = [...dataAmount]; // Burada döngüsel yapı olmamalı

      setTimeout(() => {
        this.loadChart=true 
      }, 500);
    },
  },
  mounted() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const rangeDate = [this.changeFormat(firstDayOfMonth), this.changeFormat(today)];
    this.fetchTopInfluencer(rangeDate[0], rangeDate[1]);
  },
  computed: {
    getHowMonth() {
      const monthNames = [
        'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
        'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
      ];
      const today = new Date();
      return monthNames[today.getMonth()];
    },
    totalAmount() {

    const totalAmount = this.dataList.reduce((grandTotal, product) => {
      const productTotal = product.orders.reduce((total, item) => {
        const amountStr = item.total_amount ?? '0';
        const numericAmount = typeof amountStr === 'string'
          ? parseFloat(amountStr.replace(/\./g, '')) || 0
          : amountStr;
        return total + numericAmount;
      }, 0);

      return grandTotal + productTotal;
    }, 0);

    return totalAmount ?? 0;
    },  
  }
};
</script>
